package dev.danko.roblox_craft_ai.uikit.i18n

internal fun slavicPlural(count: Int, one: String, few: String, many: String): String {
    val mod100 = count % 100
    val mod10 = count % 10
    return when {
        mod100 in 11..14 -> many
        mod10 == 1 -> one
        mod10 in 2..4 -> few
        else -> many
    }
}

/** One decimal at most ("4", "4.5"), with a comma for locales that use one. */
internal fun shortDecimal(value: Double, comma: Boolean): String {
    val rounded = kotlin.math.round(value * 10) / 10
    val text = if (rounded == kotlin.math.floor(rounded)) rounded.toLong().toString() else rounded.toString()
    return if (comma) text.replace('.', ',') else text
}

/** 12345 -> "12 345" (or "12,345" / "12.345" with another separator). */
internal fun groupDigits(value: Int, separator: String): String =
    value.toString().reversed().chunked(3).joinToString(separator).reversed()

internal fun isWhole(value: Double): Boolean = kotlin.math.round(value * 10) % 10 == 0.0
